import { TableColumn } from "react-data-table-component";
import { Fragment, useState } from "react";
import { Badges, Btn } from "../../AbstractElements";
import { RefreshCcw } from "react-feather";
import { CustomCellInterFace } from "../../Types/TablesType";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

//Modals
import UpdateDepartmentModal from "../../Components/UiKits/Modal/Department/Update";

//Services
import {
  VIEW_DEPSITE_QUERY_KEY,
  DEPSITE_QUERY_KEY,
  deploymentsiteService,
} from "../../Services/deploymentsiteService";

//Types
import { ViewDeploymentSite } from "../../Types/CompanyProfile/DeploymentSite";

const CustomBadge: React.FC<CustomCellInterFace> = ({ label, color }) => (
  <Badges pill color={color}>
    {label}
  </Badges>
);

export const StructureTableColumn: TableColumn<ViewDeploymentSite>[] = [
  {
    name: "REGION",
    selector: (row) => row.region_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{`${row.region_name}`}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "CLUSTER",
    selector: (row) => row.cluster_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{row.cluster_name}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "DEPLOYMENT SITE",
    selector: (row) => row.name,
    cell: (row) => <div style={{ whiteSpace: "pre-line" }}>{row.name}</div>,
    sortable: true,
    center: false,
  },
  // {
  //   name: "STATUS",
  //   selector: (row) => row.status_label,
  //   cell: (row) => (
  //     <>
  //       <CustomBadge
  //         color={row.status_label === "ACTIVE" ? "success" : "danger"}
  //         label={row.status_label}
  //       />
  //     </>
  //   ),
  //   width: "100px",
  //   sortable: true,
  //   center: false,
  // },
  // {
  //   name: "DATE CREATED",
  //   selector: (row) => row.created_date,
  //   cell: (row) => (
  //     <div style={{ whiteSpace: "pre-line" }}>
  //       {row.created_by_user}
  //       {"\n"}
  //       {row.created_date}
  //     </div>
  //   ),
  //   width: "180px",
  //   sortable: true,
  //   center: false,
  // },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    width: "180px",
    sortable: true,
    center: false,
  },
];
